import { RootState } from 'app/store';
import { createSlice } from '@reduxjs/toolkit';
import { DocumentType } from 'features/document/documentSlice';

interface OrganizationState {
  supportedDocTypes: string[];
}

const OrganizationInitialState: OrganizationState = {
  supportedDocTypes: [DocumentType.DOCUMENT],
};

const OrganizationSlice = createSlice({
  name: 'organization',
  initialState: OrganizationInitialState,
  reducers: {
    setSupportedDocTypes(state, action) {
      state.supportedDocTypes = action.payload;
    },
  },
  extraReducers: {},
});

export const { setSupportedDocTypes } = OrganizationSlice.actions;

export default OrganizationSlice.reducer;

export const selectSupportedDocTypes = (state: RootState) => state.organization.supportedDocTypes;
